import { render } from "./ClassMain.vue?vue&type=template&id=201e092e&scoped=true&ts=true"
import script from "./ClassMain.vue?vue&type=script&lang=ts"
export * from "./ClassMain.vue?vue&type=script&lang=ts"

import "./ClassMain.vue?vue&type=style&index=0&id=201e092e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-201e092e"]])

export default __exports__